import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddConfiguratorItemButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/configurator_items/create?configuratorConfig=${record['@id']}`}
    label="Add a configurator item"
    title="Add a configurator item"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddConfiguratorItemButton);
